import type { Route } from "../../../../../utils/models/Route";
import type { UndoCommand, CommandContext } from "../types";

/**
 * One gesture that rewrote the markers/lineStrings of several routes — e.g. a
 * locked-mode drag of the join between two routes of the same day. Replays a
 * full before/after snapshot of each.
 */
export class RouteSnapshotsCommand implements UndoCommand {
  readonly type: string;
  readonly routeKey: string;

  private changes: Array<{ routeKey: string; before: Route; after: Route }>;

  constructor(type: string, changes: Array<{ routeKey: string; before: Route; after: Route }>) {
    this.type = type;
    this.routeKey = changes[0]?.routeKey ?? '';
    this.changes = JSON.parse(JSON.stringify(changes));
  }

  undo(ctx: CommandContext): void {
    this.apply(ctx, 'before');
  }

  redo(ctx: CommandContext): void {
    this.apply(ctx, 'after');
  }

  private apply(ctx: CommandContext, side: 'before' | 'after'): void {
    for (const change of this.changes) {
      const route = ctx.state.routes[change.routeKey];
      if (!route) continue;
      const snapshot = change[side];
      route.markers = JSON.parse(JSON.stringify(snapshot.markers));
      route.lineStrings = JSON.parse(JSON.stringify(snapshot.lineStrings));
      route.updated_at = new Date();
    }
    ctx.state._statsVersion++;
  }
}
